module.exports = __webpack_public_path__ + "img/304.a173ebf4.png";